import { useEffect, useState } from 'react';

const SHORTCUTS: { key: string; label: string }[] = [
  { key: '?', label: 'show / hide this help' },
  { key: 'B', label: 'switch order side to BUY' },
  { key: 'S', label: 'switch order side to SELL' },
  { key: '↵ Enter', label: 'submit order' },
  { key: '[', label: 'previous ticker (in current category)' },
  { key: ']', label: 'next ticker (in current category)' },
  { key: 'M', label: 'jump active ticker to one of your holdings' },
  { key: 'Esc', label: 'dismiss panel / cinematic' },
];

export function KeyboardHelp() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const target = e.target as HTMLElement | null;
      if (target?.tagName === 'INPUT' || target?.tagName === 'TEXTAREA') return;
      if (e.key === '?' || (e.shiftKey && e.key === '/')) {
        e.preventDefault();
        setOpen((v) => !v);
      } else if (open && e.key === 'Escape') {
        setOpen(false);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;
  return (
    <div
      onClick={() => setOpen(false)}
      className="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-md rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-surface)] p-5 shadow-2xl"
      >
        <div className="mb-3 flex items-baseline justify-between">
          <h2 className="text-mono-md font-bold text-[var(--text-primary)]">Keyboard</h2>
          <button
            onClick={() => setOpen(false)}
            className="text-mono-xs text-[var(--text-muted)] hover:text-[var(--text-primary)]"
            aria-label="Close help"
          >
            ✕
          </button>
        </div>
        <ul className="flex flex-col gap-1.5">
          {SHORTCUTS.map((s) => (
            <li key={s.key} className="flex items-center gap-3 text-mono-sm">
              <kbd className="min-w-[60px] rounded border border-[var(--border-subtle)] bg-[var(--bg-deep)] px-2 py-0.5 text-center font-mono text-mono-xs text-[var(--accent-primary)]">
                {s.key}
              </kbd>
              <span className="text-[var(--text-secondary)]">{s.label}</span>
            </li>
          ))}
        </ul>
        <p className="mt-4 text-[10px] italic text-[var(--text-muted)]">
          shortcuts ignored while typing in inputs.
        </p>
      </div>
    </div>
  );
}
